export const DISCOUNT_CODES = [
  {
    code: 'WELCOME10',
    type: 'percent',
    value: 10,
    label: '10% off your first order',
  },
  {
    code: 'CHIKWAFU5K',
    type: 'flat',
    value: 5000,
    label: 'UGX 5,000 off',
  },
];

/**
 * Mock validation — swap this for a real API call when ready.
 * Returns { valid, discount, amount, message }
 */
export function applyDiscountCode(rawCode, subtotal) {
  const code = rawCode.trim().toUpperCase();

  if (!code) {
    return { valid: false, discount: null, amount: 0, message: 'Enter a code first.' };
  }

  const discount = DISCOUNT_CODES.find((d) => d.code === code);

  if (!discount) {
    return { valid: false, discount: null, amount: 0, message: 'That code is not valid.' };
  }

  const amount =
    discount.type === 'percent'
      ? Math.round((subtotal * discount.value) / 100)
      : Math.min(discount.value, subtotal);

  return {
    valid: true,
    discount,
    amount,
    message: `Applied: ${discount.label}`,
  };
}
